import styled, { css } from 'styled-components';
import DefaultSelect from 'components/Form/Select';
import DefaultSpinner from 'components/Spinner';
import addAlpha from 'utils/addAlpha';

export const StatusSelect = styled(DefaultSelect)`
  &.MuiInputBase-root {
    border-radius: 1.5rem;
    padding: 0 0.75rem;
    height: 3rem;
    font-size: 1.0625rem;
    line-height: 1.5rem;
    font-weight: normal;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .MuiSelect-select.MuiSelect-select {
    padding-right: 1.575rem;

    &:focus,
    &:active {
      background: inherit;
    }
  }

  .MuiSelect-icon {
    right: 1rem;
    top: 1rem;
    width: 1rem;
    height: 1rem;
  }

  ${({ value, theme }) => {
    switch (value) {
      case 'PENDING':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.yellowLight};
            color: ${theme.colors.yellowDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.yellowDark};
          }
        `;
      case 'READY':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.greenExtraLight};
            color: ${theme.colors.greenDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.greenDark};
          }
        `;
      default:
      case 'COMPLETE':
        return css`
          &.MuiInputBase-root {
            background: ${theme.colors.blueLight};
            color: ${theme.colors.blueDark};
          }
          .MuiSelect-icon {
            color: ${theme.colors.blueDark};
          }
        `;
    }
  }}
`;

export const Chip = styled.div`
  border-radius: 1.5rem;
  padding: 0 1.25rem;
  height: 3rem;
  font-size: 1.0625rem;
  line-height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
`;

export const Cancelled = styled(Chip)`
  background-color: ${({ theme }) => theme.colors.redExtraLight};
  color: ${({ theme }) => theme.colors.redDark};
`;

export const Scheduled = styled(Chip)`
  background-color: ${({ theme }) => theme.colors.navyGreenLight};
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

export const Spinner = styled(DefaultSpinner)``;
